import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-ink-card text-amber border-ink-line' : 'bg-white text-coral-deep border-cloud-dark';
  const label = tone === 'dark' ? 'text-white/60' : 'text-slate';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-89" data-mp="32500a1quo8zu">
      {units.map(unit => <div key={unit.label} className={`rounded-xl border text-center tabular-nums ${box} ${isLarge ? 'px-4 py-3 sm:px-6 sm:py-4 min-w-[74px] sm:min-w-[92px]' : 'px-3 py-2 min-w-[58px]'}`} data-id="element-90" data-mp="10aimw34dwj7b">
          <div className={`font-display font-extrabold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-91" data-mp="t123nhtc76zf">{unit.value}</div>
          <div className={`uppercase tracking-widest mt-1 font-bold ${label} ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-92" data-mp="17q6pra395vct">{unit.label}</div>
        </div>)}
    </div>;
}